import { Check, Loader2, AlertCircle } from 'lucide-react';
import type { SaveStatus } from './useAutosave.ts';

// Small, consistent "Saving… / Saved / Couldn't save" indicator for autosave panels.
export function AutosaveStatus({ status }: { status: SaveStatus }): JSX.Element | null {
  if (status === 'idle') return null;
  if (status === 'saving')
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5 text-xs text-muted-foreground" role="status">
        <Loader2 size={13} className="animate-spin" /> Saving…
      </span>
    );
  if (status === 'saved')
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5 text-xs text-[hsl(var(--success))]" role="status">
        <Check size={13} /> Saved
      </span>
    );
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 text-xs text-destructive" role="alert">
      <AlertCircle size={13} /> Couldn't save
    </span>
  );
}
